import http from "./http-common";

class LanguageService {

  async getAll() {    
   const respons= await http.get(`Language/GetAll`);    
    return respons
  }  
}
export default new LanguageService();